var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorTriangleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 732.56549,
    height: 667.76831,
    viewBox: "0 0 21.976965 20.033049",
    fill: "none",
    id: "svg3",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m 1.1901085,16.502549 7.96266,-14.4644403 c 0.7378,-1.34007998 2.9336005,-1.34007998 3.6714005,0 l 7.9627,14.4644403 c 0.6459,1.1733 -0.3386,2.5305 -1.8357,2.5305 H 3.0257685 c -1.49708,0 -2.48158996,-1.3572 -1.83566,-2.5305 z",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path1",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#ff0000",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 10.988469,7.0330487 V 11.033049",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path2",
    style: {
      stroke: "#ff0000",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 10.988469,15.052549 v -0.0195",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path3",
    style: {
      stroke: "#ff0000",
      strokeOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorTriangleIcon);
export default __webpack_public_path__ + "static/media/error_triangle_icon.ce60afd865a46e3dc45cbdaaa8411a53.svg";
export { ForwardRef as ReactComponent };